import axiosFlowIns from '@/services/axios/axiosFlow'

export default class AutoatendimentoService {
  static async getAutoatendimentoByUrlAlias(urlAlias) {
    return axiosFlowIns.get(`canais/autoatendimento/query?urlAlias=${urlAlias}`).then(res => res.data.data)
  }
}
